import Building from '@/components/structures/building'
// test
/* class Advert {
  constructor () {
    this.id = null
    this.source = null
    this.owner_status_local = null
    this.adv_status = 2
    this.adv_type = 4
    this.flat_type = 1490
    this.flat_number = null
    this.room_count = 2
    this.floor = 2
    this.flat_status = null
    this.price = 1000
    this.price_history = []
    this.area_common = '20'
    this.area_living = 0
    this.area_kitchen = 0
    this.planing_type = null
    this.description_default = null
    this.description_public = null
    this.description_service = null
    this.is_readonly = false
    this.is_published = 0
    this.is_verified = false
    this.is_editing = false
    this.building = new Building()
    this.advertPhones = []
    this.advertExtras = []
    this.advertImages = []
    this.userInCharge = null
    this.delay_until = null
    this.delay_comment = null
    this.exclusive_status = null
    this.published_at = null
  }
} */

class Advert {
  constructor () {
    this.id = null
    this.owner_status_local = null
    this.adv_status = 2
    this.adv_type = 4
    this.description_default = null
    this.description_public = null
    this.description_service = null
    this.is_readonly = false
    this.is_published = 0
    this.is_verified = false
    this.is_editing = false
    this.building = new Building()
    this.advertPhones = []
    this.advertExtras = []
    this.advertImages = []
    this.userInCharge = null
    this.delay_until = null
    this.delay_comment = null
    this.exclusive_status = null
    this.published_at = null
  }
}

export default Advert
